import Base from 'app/views/base';
import { showResponseError } from 'utils/messages';
import FulfillmentBOL from 'app/models/fulfillment_bol';

import FulfillmentBOLCreateModal from './modal';
import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'create_bol_button',

  events: {
    'click button': 'showModal',
  },

  initialize({ apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;
    this.initializeModal();
  },

  showModal() {
    this.modal.show();
  },

  onCreateSuccess(BOL) {
    this.trigger('create:success', BOL);
  },

  onCreateError(response) {
    showResponseError(response);
  },

  resetModal(BOL) {
    this.modal.remove();
    this.model = BOL;
    this.initializeModal();
  },

  initializeModal() {
    this.model = this.model || new FulfillmentBOL({
      ...this.apiModeSelection.getParams(),
    });

    this.modal = new FulfillmentBOLCreateModal({
      collection: this.collection,
      apiModeSelection: this.apiModeSelection,
      bol: this.model,
      weekOfDelivery: this.model.get('week_of_delivery'),
      warehouseAddress: this.model.get('warehouse_address'),
      trackingCode: this.model.get('tracking_code'),
      bolCSV: this.model.get('csv'),
    });

    this.modal.on('create:success', this.onCreateSuccess.bind(this));
    this.modal.on('create:error', this.onCreateError.bind(this));
    this.modal.on('closed', this.resetModal.bind(this));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/fulfillment_bols/create/index.js